import { FormHelperText, HelperText, HelperTextItem } from '@patternfly/react-core';
import { ExclamationCircleIcon, ExclamationTriangleIcon, CheckCircleIcon } from '@patternfly/react-icons';

import { PatternFlyValidated } from './validation-types';
import './validation-helper-text.css';

interface ValidationHelperTextProps {
    validated: PatternFlyValidated | undefined;
    helperText?: string | null;
}

const getValidationIcon = (validated: PatternFlyValidated | undefined) => {
    switch (validated) {
        case 'error':
            return <ExclamationCircleIcon />;
        case 'warning':
            return <ExclamationTriangleIcon />;
        case 'success':
            return <CheckCircleIcon />;
        case 'default':
            return undefined;
        default:
            return undefined;
    }
}

const ValidationHelperText = ({ validated, helperText }: ValidationHelperTextProps) => {
    // Return null if no helper text is provided
    if (!helperText || !validated) return null;

    return (
        <FormHelperText className='selectable'>
            <HelperText>
                <HelperTextItem icon={getValidationIcon(validated)} variant={validated} className={`validation-helper-text-${validated}`}>
                    {helperText}
                </HelperTextItem>
            </HelperText>
        </FormHelperText>
    );
};

export default ValidationHelperText;
